import { StoreItem, CustomizationCategory } from './types';
import {
    EmojiIcon,
    SettingsIcon,
    TrophyIcon,
    PlusIcon,
    GlobeIcon,
    SparklesIcon,
    ImageIcon
} from './components/Icons';

export const STORE_ITEMS: StoreItem[] = [
    {
        id: 'classic_postcards',
        name: 'Classic Postcard',
        description: 'The standard rounded corner box of your theme.',
        price: 0,
        artist: 'vibeman1',
        category: 'postcards',
        previewData: { type: 'postcard' }
    },
    {
        id: 'postcard_full',
        name: 'Full Screen',
        description: 'Sharp corners, edge-to-edge content. No margins.',
        price: 0,
        artist: 'vibeman1',
        category: 'postcards',
        previewData: { type: 'postcard_full' }
    },
    {
        id: 'postcard_sticky',
        name: 'Sticky Classic',
        description: 'Classic rounded corners, but stuck together without gaps.',
        price: 0,
        artist: 'vibeman1',
        category: 'postcards',
        previewData: { type: 'postcard' }
    },
    // Default "classic" items for each category
    { id: 'classic_animations', name: 'Classic Animations', description: 'Standard app transitions.', price: 0, artist: 'vibeman1', category: 'animations' },
    { id: 'classic_bubbles', name: 'Classic Bubbles', description: 'Standard chat bubbles.', price: 0, artist: 'vibeman1', category: 'bubbles' },
    { id: 'classic_stickers', name: 'Classic Stickers', description: 'Standard sticker set.', price: 0, artist: 'vibeman1', category: 'stickers' },
    { id: 'classic_themes', name: 'Classic Themes', description: 'Standard app color palettes.', price: 0, artist: 'vibeman1', category: 'themes' },
    { id: 'classic_icons', name: 'Classic Icons', description: 'Standard interface icons.', price: 0, artist: 'vibeman1', category: 'icons' },
    { id: 'classic_fonts', name: 'Classic Fonts', description: 'Standard system fonts.', price: 0, artist: 'vibeman1', category: 'fonts' },
    { id: 'classic_pfp_themes', name: 'Classic PFP Themes', description: 'Standard profile picture frames.', price: 0, artist: 'vibeman1', category: 'pfp_themes' },
    { id: 'classic_navbar', name: 'Classic Navbar', description: 'Standard navigation bar style.', price: 0, artist: 'vibeman1', category: 'navbar' },

    // Premium Placeholders
    { id: 'placeholder_animations', name: 'Premium Animations', description: 'Coming soon.', price: 1500, category: 'animations' },
    { id: 'placeholder_bubbles', name: 'Glass Bubbles', description: 'Coming soon.', price: 2000, category: 'bubbles' },
    { id: 'placeholder_stickers', name: 'Designer Stickers', description: 'Coming soon.', price: 500, category: 'stickers' },
    { id: 'placeholder_themes', name: 'Vibrant Themes', description: 'Coming soon.', price: 4000, category: 'themes' },
    { id: 'placeholder_icons', name: 'Custom Icons', description: 'Coming soon.', price: 2000, category: 'icons' },
    {
        id: 'mod_todo',
        name: 'Perfect To-Do List',
        description: 'A modular task manager with smart reminders and notifications.',
        price: 0,
        artist: 'agk',
        category: 'mods',
        previewData: { type: 'mod' }
    },
    {
        id: 'mod_art_class',
        name: 'Art Class',
        description: 'The ultimate creator studio for postcards and stickers.',
        price: 0,
        artist: 'vibeman1',
        category: 'mods',
        previewData: { type: 'mod' }
    },
    {
        id: 'mod_daily_footprint',
        name: 'Daily Footprint',
        description: 'Track your daily impact and earn Lyfe Points.',
        price: 0,
        artist: 'vibeman1',
        category: 'mods',
        previewData: { type: 'mod' }
    },
];

export const CATEGORIES: { id: CustomizationCategory, name: string, icon: any }[] = [
    { id: 'postcards', name: 'Postcards', icon: ImageIcon },
    { id: 'animations', name: 'Animations', icon: SparklesIcon },
    { id: 'bubbles', name: 'Chat Bubbles', icon: GlobeIcon },
    { id: 'stickers', name: 'Stickers', icon: EmojiIcon },
    { id: 'themes', name: 'Themes', icon: TrophyIcon },
    { id: 'icons', name: 'Icons', icon: SettingsIcon },
    { id: 'mods', name: 'Mods', icon: SparklesIcon },
    { id: 'more', name: 'More', icon: PlusIcon },
];

export const FONT_OPTIONS = [
    { id: 'default', name: 'Default', family: 'inherit' },
    { id: 'font_tiktok_classic', name: 'TikTok Classic', family: '"Proxima Nova", "TikTok Sans", "Helvetica Neue", Helvetica, Arial, sans-serif' },
    { id: 'font_tiktok_typewriter', name: 'TikTok Typewriter', family: '"Courier New", Courier, monospace' },
    { id: 'font_tiktok_handwriting', name: 'TikTok Handwriting', family: '"Comic Sans MS", cursive, sans-serif' },
    { id: 'font_tiktok_neon', name: 'TikTok Neon', family: '"Varela Round", "Arial Rounded MT Bold", sans-serif' },
    { id: 'font_tiktok_serif', name: 'TikTok Serif', family: 'Georgia, "Times New Roman", Times, serif' },
    { id: 'font_serif', name: 'Serif', family: 'Georgia, serif' },
    { id: 'font_mono', name: 'Mono', family: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace' },
    { id: 'font_cursive', name: 'Cursive', family: '"Comic Sans MS", cursive, sans-serif' },
    { id: 'font_inter', name: 'Inter', family: '"Inter", sans-serif' },
    { id: 'font_playfair', name: 'Playfair', family: '"Playfair Display", serif' },
    { id: 'font_roboto_mono', name: 'Roboto Mono', family: '"Roboto Mono", monospace' },
    { id: 'font_pacifico', name: 'Pacifico', family: '"Pacifico", cursive' },
    { id: 'font_bangers', name: 'Bangers', family: '"Bangers", cursive' },
    { id: 'font_outfit', name: 'Outfit', family: '"Outfit", sans-serif' },
    { id: 'font_roboto', name: 'Roboto', family: '"Roboto", sans-serif' },
    { id: 'font_open_sans', name: 'Open Sans', family: '"Open Sans", sans-serif' },
    { id: 'font_lato', name: 'Lato', family: '"Lato", sans-serif' },
    { id: 'font_montserrat', name: 'Montserrat', family: '"Montserrat", sans-serif' },
    { id: 'font_oswald', name: 'Oswald', family: '"Oswald", sans-serif' },
    { id: 'font_raleway', name: 'Raleway', family: '"Raleway", sans-serif' },
    { id: 'font_merriweather', name: 'Merriweather', family: '"Merriweather", serif' },
    { id: 'font_dancing_script', name: 'Dancing', family: '"Dancing Script", cursive' },
    { id: 'font_lobster', name: 'Lobster', family: '"Lobster", cursive' },
    { id: 'font_caveat', name: 'Caveat', family: '"Caveat", cursive' },
    { id: 'font_permanent_marker', name: 'Marker', family: '"Permanent Marker", cursive' },
    { id: 'font_righteous', name: 'Righteous', family: '"Righteous", cursive' },
    { id: 'font_creepster', name: 'Creepster', family: '"Creepster", cursive' },
    { id: 'font_press_start_2p', name: '8-Bit', family: '"Press Start 2P", cursive' },
    { id: 'font_monoton', name: 'Monoton', family: '"Monoton", cursive' },
    { id: 'font_vt323', name: 'VT323', family: '"VT323", monospace' },
    { id: 'font_bebas_neue', name: 'Bebas Neue', family: '"Bebas Neue", sans-serif' },
    { id: 'font_anton', name: 'Anton', family: '"Anton", sans-serif' },
    { id: 'font_josefin_sans', name: 'Josefin', family: '"Josefin Sans", sans-serif' },
    { id: 'font_comfortaa', name: 'Comfortaa', family: '"Comfortaa", cursive' },
    { id: 'font_shadows_into_light', name: 'Shadows', family: '"Shadows Into Light", cursive' },
    { id: 'font_amatic_sc', name: 'Amatic', family: '"Amatic SC", cursive' },
    { id: 'font_indie_flower', name: 'Indie Flower', family: '"Indie Flower", cursive' },
    { id: 'font_kalam', name: 'Kalam', family: '"Kalam", cursive' },
    { id: 'font_satisfy', name: 'Satisfy', family: '"Satisfy", cursive' },
    { id: 'font_courgette', name: 'Courgette', family: '"Courgette", cursive' },
    { id: 'font_great_vibes', name: 'Great Vibes', family: '"Great Vibes", cursive' },
    { id: 'font_bungee', name: 'Bungee', family: '"Bungee", cursive' },
    { id: 'font_alfa_slab_one', name: 'Alfa Slab', family: '"Alfa Slab One", cursive' },
    { id: 'font_abril_fatface', name: 'Abril', family: '"Abril Fatface", cursive' },
    { id: 'font_system', name: 'System Default', family: 'system-ui' },
    { id: 'font_arial', name: 'Arial', family: 'Arial' },
    { id: 'font_courier', name: 'Courier New', family: '"Courier New"' },
    { id: 'font_georgia', name: 'Georgia', family: 'Georgia' },
    { id: 'font_times', name: 'Times New Roman', family: '"Times New Roman"' },
    { id: 'font_verdana', name: 'Verdana', family: 'Verdana' },
    { id: 'font_trebuchet', name: 'Trebuchet MS', family: '"Trebuchet MS"' },
    { id: 'font_impact', name: 'Impact', family: 'Impact' },
    { id: 'font_printer', name: 'Printer', family: '"Printer", monospace' },
    { id: 'font_typewriter', name: 'Typewriter', family: '"Typewriter", monospace' },
    { id: 'font_lyrical', name: 'Lyrical', family: '"Lyrical", cursive' },
    { id: 'font_ice_cube', name: 'Ice Cube', family: '"Ice Cube", sans-serif' },
    { id: 'font_verve', name: 'Verve', family: '"Verve", sans-serif' },
    { id: 'font_oxygen', name: 'Oxygen', family: '"Oxygen", sans-serif' },
    { id: 'font_ubuntu', name: 'Ubuntu', family: '"Ubuntu", sans-serif' },
    { id: 'font_long_cang', name: 'Long Cang', family: '"Long Cang", cursive' },
    { id: 'font_bad_script', name: 'Bad Script', family: '"Bad Script", cursive' },
    { id: 'font_star', name: 'Star', family: '"Star", cursive' },
    { id: 'font_benguiatb', name: 'BenguiatB', family: '"BenguiatB", serif' },
    { id: 'font_yeseva', name: 'Yeseva', family: '"Yeseva One", serif' },
    { id: 'font_elegance', name: 'Elegance', family: '"Elegance", serif' },
    { id: 'font_retro', name: 'Retro', family: '"Retro", sans-serif' },
    { id: 'font_tallhaus', name: 'TALLHAUS', family: '"TALLHAUS", sans-serif' },
    { id: 'font_vintage', name: 'Vintage', family: '"Vintage", serif' },
    { id: 'font_bomb', name: 'Bomb', family: '"Bomb", sans-serif' },
    { id: 'font_signature', name: 'Signature', family: '"Signature", cursive' },
    { id: 'font_facon', name: 'Facon', family: '"Facon", sans-serif' },
    { id: 'font_reenie', name: 'Reenie', family: '"Reenie Beanie", cursive' },
    { id: 'font_rock_salt', name: 'Rock Salt', family: '"Rock Salt", cursive' },
    { id: 'font_zen_loop', name: 'Zen Loop', family: '"Zen Loop", sans-serif' },
    { id: 'font_public_sans', name: 'Public Sans', family: '"Public Sans", sans-serif' },
    { id: 'font_barlow', name: 'Barlow', family: '"Barlow", sans-serif' },
    { id: 'font_futuristic', name: 'Futuristic', family: '"Orbitron", sans-serif' },
    { id: 'font_onest', name: 'Onest', family: '"Onest", sans-serif' },
    { id: 'font_modern', name: 'Modern', family: '"Modern", sans-serif' },
    { id: 'font_allison', name: 'Allison', family: '"Allison", cursive' },
    { id: 'font_playpen', name: 'Playpen', family: '"Playpen Sans", sans-serif' },
    { id: 'font_encode', name: 'Encode', family: '"Encode Sans", sans-serif' },
    { id: 'font_vouge', name: 'Vouge', family: '"Vouge", serif' },
    { id: 'font_nunito', name: 'Nunito', family: '"Nunito", sans-serif' },
    { id: 'font_archive', name: 'Archive', family: '"Archive", sans-serif' },
    { id: 'font_unbounded', name: 'Unbounded', family: '"Unbounded", sans-serif' },
    { id: 'font_carattere', name: 'Carattere', family: '"Carattere", cursive' },
    { id: 'font_poppins', name: 'Poppins', family: '"Poppins", sans-serif' },
    { id: 'font_alegreya', name: 'Alegreya', family: '"Alegreya", serif' },
    { id: 'font_bevan', name: 'Bevan', family: '"Bevan", serif' },
    { id: 'font_dynapuff', name: 'DynaPuff', family: '"DynaPuff", cursive' },
    { id: 'font_evangel', name: 'Evangel', family: '"Evangel", serif' },
    { id: 'font_barlowe', name: 'BarlowE', family: '"Barlow Condensed", sans-serif' },
    { id: 'font_ysabeau', name: 'Ysabeau', family: '"Ysabeau", sans-serif' },
    { id: 'font_gensenb', name: 'GenSenB', family: '"GenSenRounded", sans-serif' },
    { id: 'font_noto', name: 'Noto', family: '"Noto Sans", sans-serif' },
    { id: 'font_cormorant', name: 'Cormorant', family: '"Cormorant", serif' },
    { id: 'font_xioawei', name: 'XioaWei', family: '"ZCOOL XiaoWei", serif' },
    { id: 'font_uoqmun', name: 'UoqMun', family: '"UoqMun", sans-serif' },
    { id: 'font_zcool', name: 'Zcool', family: '"ZCOOL KuaiLe", cursive' },
    { id: 'font_potta', name: 'Potta', family: '"Potta One", cursive' },
    { id: 'font_science', name: 'Science', family: '"Science", sans-serif' },
    { id: 'font_rubik', name: 'Rubik', family: '"Rubik", sans-serif' },
    { id: 'font_libreral', name: 'Libreral', family: '"Libre Baskerville", serif' },
];
